module.exports = __webpack_public_path__ + "img/Group2.9f5966c0.svg";